export default __webpack_public_path__ + "static/media/image-play.cfd130c4.png";